import Vue from 'vue'
import {Howl} from 'howler';

const vi = new Vue();

const error = (text) => {
  vi.$vs.notify({
    title: 'Error',
    color: 'danger',
    text
  })
};

const success = (text) => {
  vi.$vs.notify({
    title: 'Success',
    color: 'success',
    text
  })
};

const notificationPopup = ({title, text, icon, color = 'primary'}) => {
  const sound = new Howl({
    html5: true,
    autoplay: true,
    src: ['audio/ting.mp3'],
    volume: 1,
  });
  sound.play();
  return new Promise((resolve) => {
    vi.$vs.notify({
      time: 10000,
      title,
      text,
      iconPack: 'feather',
      icon,
      color,
      click: () => {
        resolve();
      },
    })
  });
};

Vue.prototype.$notificationService = {error, success, notificationPopup};
